import { api } from "./axios"
import { axiosApp } from "./axiosApp";
import { axiosAuth } from "./axiosAuth";

// Create a new user (Admin only)
export const createUser = async (userData) => {
    try {
        const res = await api.post('/users', userData);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Get all users with pagination and search
export const getAllUsers = async (params = {}) => {
    try {
        const res = await axiosApp.get('/users', { params });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Get user statistics for admin dashboard
export const getUserStats = async () => {
    try {
        const res = await axiosApp.get('/users/stats');
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Update user status
export const updateUserStatus = async (userId, status) => {
    try {
        const res = await axiosApp.put(`/users/${userId}/status`, { status });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Update user role
export const updateUserRole = async (userId, role) => {
    try {
        const res = await axiosApp.put(`/users/${userId}/role`, { role });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Delete user
export const deleteUser = async (userId) => {
    try {
        const res = await axiosApp.delete(`/users/${userId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}



// Reset password
export const resetPassword = async (token, newPassword) => {
    try {
        const res = await axiosApp.post('/auth/reset-password', { token, newPassword });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}


export const verifyResetToken = async (token) => {
    try {
        const res = await axiosApp.get(`/auth/verify-reset-token?token=${token}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

export const logoutApi = async () => {
    try {
        const res = await axiosAuth.post('/auth/logout', {})
        return res.data
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}
